<template>
  <section id="warranty-form-section">
    <div
      v-if="!formSubmitted"
      class="container">
      <div class="row">
        <h1>Warranty Registration</h1>
      </div>

      <div class="row">
        <div class="twelve columns">
          <h3>Personal Information</h3>

          <div class="form-row">
            <input
              v-model.trim="firstName"
              type="text"
              placeholder="First Name"
              name="first_name"
              value
              class="form-half"
              required
              autocomplete="given-name"
            >
            <input
              v-model.trim="lastName"
              type="text"
              placeholder="Last Name"
              name="last_name"
              value
              class="form-half"
              required
              autocomplete="family-name"
            >
          </div>

          <div class="form-row">
            <input
              v-model.trim="addressLineOne"
              type="text"
              placeholder="Address"
              name="address_one"
              value
              class="form-full"
              required
              autocomplete="address-line1"
            >
            <input
              v-model.trim="addressLineTwo"
              type="text"
              placeholder="Address 2"
              name="address_two"
              value
              class="form-full"
              autocomplete="address-line2"
            >
          </div>

          <div class="form-row">
            <input
              v-model.trim="city"
              type="text"
              placeholder="City"
              name="city_field"
              value
              class="form-third"
              autocomplete="city"
              required
            >
            <select
              v-model.trim="state"
              class="form-third"
              name="state_field"
              autocomplete="state"
              required
            >
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
            <input
              v-model.trim="zip"
              type="text"
              placeholder="Zip Code"
              name="zip_code"
              class="form-third"
              required
              autocomplete="postal-code"
            >
          </div>

          <div class="form-row">
            <input
              v-model.trim="emailAddress"
              type="email"
              placeholder="Email"
              name="email_field"
              class="form-half"
              required
              autocomplete="email"
            >
            <input
              v-model.trim="phoneNumber"
              type="tel"
              placeholder="Phone"
              name="phone_field"
              class="form-half"
              required
              autocomplete="tel"
            >
          </div>

          <h3>Product Information</h3>

          <div class="form-row">
            <input
              v-model.trim="purchasePlace"
              type="text"
              placeholder="Place of purchase name"
              name="place_of_purchase"
              class="form-full"
              required
            >
          </div>

          <div class="form-row">
            <input
              v-model.trim="datePurchase"
              type="date"
              placeholder="Date of purchase (mm/dd/yyyy)"
              name="date_of_purchase"
              class="form-half"
              required
            >
            <input
              v-model.trim="serialNumber"
              type="text"
              placeholder="Product serial number"
              name="serial_number"
              class="form-half"
              required
            >
          </div>

          <div class="form-row">
            <textarea
              v-model.trim="customerComments"
              placeholder="Comments"
              class="form-full"
              name="customer_comments"
              rows="10"
            ></textarea>
            <button
              v-if="!formSubmitted"
              name="submit_registration_form"
              class="button buy-button"
              @click.prevent="submitRegistration"
            >Submit</button>

            <div
              v-else
              class="button processing">
              <no-ssr>
                <spinner
                  size="small"
                  line-fg-color="#002554"></spinner>
              </no-ssr>
              <span>Submitting Registration</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-else
      class="cart__empty">
      <h1>Thank You!</h1>
      <p>Product Registration Submitted</p>
      <router-link
        to="/"
        class="button more-info-button">Home</router-link>
    </div>

    <no-ssr>
      <notifications
        classes="coupon-valid-notification"
        group="registrationInvalid"
        position="top left"
      />
    </no-ssr>
  </section>
</template>

<script>
import { required, minLength, maxLength, integer, alpha, email } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    firstName: '',
    lastName: '',
    addressLineOne: '',
    addressLineTwo: '',
    city: '',
    state: '',
    zip: '',
    emailAddress: '',
    phoneNumber: '',
    purchasePlace: '',
    datePurchase: '',
    serialNumber: '',
    customerComments: '',
    submittingData: false,
    formSubmitted: false
  }),
  validations: {
    firstName: {
      required,
      alpha,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    lastName: {
      required,
      alpha,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    addressLineOne: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    city: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    state: {
      required,
      alpha,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    zip: {
      required,
      integer,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    emailAddress: {
      required,
      email,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    phoneNumber: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    purchasePlace: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    datePurchase: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(200)
    },
    serialNumber: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(200)
    }
  },
  computed: {
    ...mapGetters('token', {
      getToken: 'getToken'
    })
  },
  methods: {
    getFormData () {
      return {
        firstName: this.firstName,
        lastName: this.lastName,
        addressLineOne: this.addressLineOne,
        addressLineTwo: this.addressLineTwo,
        city: this.city,
        state: this.state,
        zip: this.zip,
        emailAddress: this.emailAddress,
        phoneNumber: this.phoneNumber,
        purchasePlace: this.purchasePlace,
        datePurchase: this.datePurchase,
        serialNumber: this.serialNumber,
        customerComments: this.customerComments
      }
    },
    async submitRegistration () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.$notify({
          group: 'registrationInvalid',
          title: 'There was an issue.',
          text: 'Please try fixing your information, or try again.',
          type: 'error'
        })
      } else {
        // Change status of button
        this.submittingData = true

        // Gather form data
        const formData = this.getFormData()
        let { data } = await this.$axios.post('/api/warranty-registration', formData)
          .catch(() => {
            this.$notify({
              group: 'registrationInvalid',
              title: 'There was an issue.',
              text: 'Please try fixing your information, or try again.',
              type: 'error'
            })
          })
        if (data) {
          this.formSubmitted = true
          this.$notify({
            group: 'registrationInvalid',
            title: 'Submitted',
            text: 'Your registration was submitted.',
            type: 'success'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#warranty-form-section {
  @include section__container;
  padding: 60px 7%;

  h1 {
    margin: 15px 0;
  }

  h3 {
    font-size: 21px;
    border-bottom: 1px solid $grey;
    margin-top: 30px;
    margin-bottom: 25px;
    padding-bottom: 15px;
    font-weight: bold;
    width: 67%;

    @media screen and (max-width: 850px) {
      width: 100%;
    }
  }

  .form-row {
    width: 67%;
    margin: 0;
    padding: 0;

    @include clearfix();

    @media screen and (max-width: 850px) {
      width: 100%;
    }
  }

  textarea {
    padding: 17px;
  }

  form {
    margin-bottom: 40px;
  }

  @media screen and (max-width: 600px) {
    padding: 40px 0;
  }
}
.cart {
  @include e("empty") {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    padding: 65px 8.5%;
  }
}

.processing {
  max-width: 250px;
  display: flex;
  flex-direction: row;
  font-size: 18px;
  align-items: center;
  padding: 15px;
  background: #c7c7c7;
  text-align: center;
  justify-content: center;
  transition: all 0.25s ease-in;

  span {
    margin-left: 12px;
  }
}
</style>
